// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".pill-text{font-size:1.062rem}.pill-wrapper .theme--light.v-btn:hover:before{opacity:0}.pill-wrapper .theme--light.v-btn:focus:before,.pill-wrapper .theme--light.v-btn:hover:before{opacity:0!important}.pill-wrapper .v-ripple__container{display:none!important}.pill-wrapper .svg-pill{transition:all .2s ease-in-out}.pill-wrapper .svg-pill:hover{transform:scale(1.1)}", ""]);
// Exports
module.exports = exports;
